export const seelIntegrationType = 'seel'

export const defaultFulfillmentTrigger = 'all_fulfilled'

export const shopifyThemeEditorPath = '/admin/themes/current/editor?context=apps'

export const fulfillmentTriggerLabels = {
  first_fulfillment: 'Cuando se envía el primer paquete',
  all_fulfilled: 'Cuando se envían todos los items',
  immediately: 'Inmediatamente al crear el pedido',
}
